import { useEffect, useState } from "react";
import { Button, Input, Select, Tag, Tooltip } from "antd";
import { OpportunityTagModel } from "../../../../../dto/admin-rule-models";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;
const colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
] as const;

type SetOpportunityTagType = {
  actionValue: string;
  onChange: (value: string) => void;
};

export const SetOpportunityTag = ({
  actionValue,
  onChange,
}: SetOpportunityTagType) => {
  const [tagModels, setTagModels] = useState<OpportunityTagModel[]>([]);

  useEffect(() => {
    if (!actionValue) {
      return;
    }
    const parsed = JSON.parse(actionValue) as OpportunityTagModel[];
    const tagModels = parsed?.map(x => ({
      ...x,
      feId: crypto.randomUUID(),
    }));
    setTagModels(tagModels);
  }, [actionValue]);

  const handleTextChange = (feId: string, value: string) => {
    const updatedList = tagModels.map(item =>
      item.feId === feId
        ? { ...item, value }
        : item
    );
    setTagModels(updatedList);
    onChange(JSON.stringify(updatedList));
  };

  const handleColorChange = (feId: string, color: string) => {
    const updatedList = tagModels.map(item =>
      item.feId === feId
        ? { ...item, color }
        : item
    );
    setTagModels(updatedList);
    onChange(JSON.stringify(updatedList));
  };

  const addTagModel = () => {
    setTagModels([...tagModels, { feId: crypto.randomUUID(), color: '', value: '' }]);
  };

  const handleDeleteRow = (feId: string) => {
    const updatedList = tagModels.filter(item => item.feId !== feId);
    setTagModels(updatedList);
    onChange(JSON.stringify(updatedList));
  };

  return (
    <div>
      {tagModels && tagModels?.map((tagModel, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>

          <Input
            style={{ width: 140, marginRight: 10 }}
            placeholder="Tag text"
            value={tagModel.value}
            onChange={(e) => handleTextChange(tagModel.feId, e.target.value)}
          />
          <Select
            style={{ width: 130, overflow: 'hidden' }}
            placeholder="Tag color"
            value={tagModel.color}
            onChange={(e) => handleColorChange(tagModel.feId, e)}
          >
            {colors.map((c) => (
              <Option key={c} value={c}>
                <Tag color={c}>color</Tag>
              </Option>
            ))}
          </Select>
          <Tooltip title="This will delete the current row">
            <button
              type="button"
              onClick={() => handleDeleteRow(tagModel.feId)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--text-secondary)',
                cursor: 'pointer',
                fontSize: 16,
                marginLeft: 0,
                padding: 0
              }}
              aria-label="Delete row"
            >
              ×
            </button>
          </Tooltip>
        </div>
      ))}
      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={addTagModel}
        style={{ marginBottom: 16 }}
      >
        Add Row
      </Button>
    </div>
  );
};